(function () {
  // ============== START ISOTOPE =================================================
  let $container;
  let filters = {};
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("safari") != -1) {
    if (ua.indexOf("chrome") > -1) {
      console.log("chrome"); // Chrome
    } else {
      console.log("safari"); // Safari
    }
  }

  $(function () {
    $container = $('[data-name="inspired-grid"]');
    $container.isotope({
      layoutMode: "masonry",
      percentPosition: true,
      itemSelector: '[data-name="inpired-item"]',
      visibleStyle: { opacity: 1 },
      hiddenStyle: { opacity: 0 },
    });

    if (!window.location.href.includes("#filters&")) {
      $container.isotope("shuffle");
    } else {
      setTimeout(() => {
        $container.isotope("shuffle");
      }, 800);
    }

    // setTimeout(() => {
    //   $container.isotope("layout");
    // }, 1000);

    // setTimeout(function () {
    //   $container.isotope("layout");
    // }, 2000);

    $("#options").on("change", function (jQEvent) {
      const $checkbox = $(jQEvent.target);
      manageCheckbox($checkbox);
      const comboFilter = getComboFilter(filters);
      $container.isotope({ filter: comboFilter });
      setTimeout(() => {
        $container.isotope("layout");
      }, 500);

      lottieLoaderPlaceholder();
      document.querySelectorAll('[data-name="inspiration-filter"]').forEach((filter) => {
        const expr = filter.getAttribute("data-group");
        if (filter.querySelectorAll("input:checked").length > 0) {
          switch (expr) {
            case "room":
              filter.querySelector("button").classList.add("DotActive");
              break;
            case "color":
              filter.querySelector("button").classList.add("DotActive");
              break;
            case "products":
              filter.querySelector("button").classList.add("DotActive");
              break;
            case "envi":
              filter.querySelector("button").classList.add("DotActive");
              break;
            case "tags":
              filter.querySelector("button").classList.add("DotActive");
              break;
            default:
              filter.querySelector("button").classList.remove("DotActive");
          }
        } else {
          switch (expr) {
            case "room":
              filter.querySelector("button").classList.remove("DotActive");
              break;
            case "color":
              filter.querySelector("button").classList.remove("DotActive");
              break;
            case "products":
              filter.querySelector("button").classList.remove("DotActive");
              break;
            case "envi":
              filter.querySelector("button").classList.remove("DotActive");
              break;
            case "tags":
              filter.querySelector("button").classList.remove("DotActive");
              break;
            default:
              filter.querySelector("button").classList.remove("DotActive");
          }
        }
      });

      setTimeout(() => {
        document.querySelector('[data-name="search-inspi-input"]').value = "";
        document.querySelector('[data-name="search-inspi-input"]').blur();
      }, 200);

      // console.log($container.data("isotope").filteredItems.length);

      setTimeout(() => {
        if ($container.data("isotope").filteredItems.length < 1) {
          document.querySelector('[data-name="inspiration-empty-state"]').style.opacity = 1;
          document.querySelector('[data-name="inspiration-empty-state"]').style.pointerEvents = "all";
        } else {
          document.querySelector('[data-name="inspiration-empty-state"]').style.opacity = 0;
          document.querySelector('[data-name="inspiration-empty-state"]').style.pointerEvents = "none";
        }
      }, 4000);

      if (document.querySelectorAll('[data-name="inspiration-filters"] input:checked').length > 0) {
        document.querySelector('[data-name="tag-filter-clear-btn"]').classList.add("Active");
      } else {
        document.querySelector('[data-name="tag-filter-clear-btn"]').classList.remove("Active");
      }
      queriesCreator();
      document.getElementById("filters").scrollIntoView();
    });
  });

  function getComboFilter(filters) {
    let i = 0;
    let comboFilters = [];
    let message = [];
    for (let prop in filters) {
      message.push(filters[prop].join(" "));
      const filterGroup = filters[prop];
      // skip to next filter group if it doesn't have any values
      if (!filterGroup.length) {
        continue;
      }
      if (i === 0) {
        // copy to new array
        comboFilters = filterGroup.slice(0);
      } else {
        const filterSelectors = [];
        // copy to fresh array
        const groupCombo = comboFilters.slice(0); // [ A, B ]
        // merge filter Groups
        for (var k = 0, len3 = filterGroup.length; k < len3; k++) {
          for (var j = 0, len2 = groupCombo.length; j < len2; j++) {
            filterSelectors.push(groupCombo[j] + filterGroup[k]); // [ 1, 2 ]
          }
        }
        // apply filter selectors to combo filters for next group
        comboFilters = filterSelectors;
      }
      i++;
    }
    let comboFilter = comboFilters.join(", ");
    return comboFilter;
  }

  function manageCheckbox($checkbox) {
    const checkbox = $checkbox[0];

    const group = $checkbox.parents(".option-set").attr("data-group");
    // create array for filter group, if not there yet
    let filterGroup = filters[group];
    if (!filterGroup) {
      filterGroup = filters[group] = [];
    }

    const isAll = $checkbox.hasClass("all");
    // reset filter group if the all box was checked
    if (isAll) {
      delete filters[group];
      if (!checkbox.checked) {
        checkbox.checked = "checked";
      }
    }
    // index of
    const index = $.inArray(checkbox.value, filterGroup);

    if (checkbox.checked) {
      const selector = isAll ? "input" : "input.all";
      $checkbox.siblings(selector).removeAttr("checked");

      if (!isAll && index === -1) {
        // add filter to group
        filters[group].push(checkbox.value);
      }
    } else if (!isAll) {
      // remove filter from group
      filters[group].splice(index, 1);
      // if unchecked the last box, check the all
      if (!$checkbox.siblings("[checked]").length) {
        $checkbox.siblings("input.all").attr("checked", "checked");
      }
    }
  }
  // ============== END ISOTOPE =================================================

  // ============== START DESKTOP FILTERS =================================================
  // Show and hide filters
  const roomFilterBtn = document.querySelector('[data-tag="room-filter-btn"]');
  const colorFilterBtn = document.querySelector('[data-tag="color-filter-btn"]');
  const prodFilterBtn = document.querySelector('[data-tag="prod-filter-btn"]');
  const envFilterBtn = document.querySelector('[data-tag="env-filter-btn"]');
  const tagFilterBtn = document.querySelector('[data-tag="tag-filter-btn"]');

  function hideUnactiveFilters(e) {
    document.querySelectorAll('[data-name="inspiration-filter-btn"]').forEach((btn) => {
      if (btn.classList.contains("Active") && !e.currentTarget.classList.contains("Active")) {
        btn.nextElementSibling.classList.remove("Active");
        btn.classList.remove("Active");
      }
    });
  }

  function showAndHideInspirationFilters(e) {
    hideUnactiveFilters(e);
    if (e.currentTarget.classList.contains("Active")) {
      e.currentTarget.classList.remove("Active");
      e.currentTarget.nextElementSibling.classList.remove("Active");
    } else {
      e.currentTarget.classList.add("Active");
      e.currentTarget.nextElementSibling.classList.add("Active");
    }
  }

  roomFilterBtn.addEventListener("click", showAndHideInspirationFilters);
  colorFilterBtn.addEventListener("click", showAndHideInspirationFilters);
  prodFilterBtn.addEventListener("click", showAndHideInspirationFilters);
  envFilterBtn.addEventListener("click", showAndHideInspirationFilters);
  tagFilterBtn.addEventListener("click", showAndHideInspirationFilters);

  // Show and hide search
  const searchResultsContainer = document.querySelector('[data-name="search-results-container"]');
  const getInspiBtn = document.querySelector('[data-name="get-inspi-btn"]');
  const searchInspiInput = document.querySelector('[data-name="search-inspi-input"]');
  const searchInspiInputWrapper = document.querySelector('[data-name="search-inspi-input-wrapper"]');

  function showAndHideInput(e) {
    searchResultsContainer.classList.toggle("Active");
    hideUnactiveFilters(e);
  }

  function showSearchResults() {
    searchInspiInputWrapper.classList.add("Active");
  }
  function hideSearchResults() {
    setTimeout(() => {
      searchInspiInputWrapper.classList.remove("Active");
      searchResultsContainer.classList.remove("Active");
    }, 300);
  }

  getInspiBtn.addEventListener("click", showAndHideInput);
  searchInspiInput.addEventListener("focus", showSearchResults);
  searchInspiInput.addEventListener("focusout", hideSearchResults);
  // ============== END DESKTOP FILTERS =================================================

  // ============== START MOBILE FILTERS =================================================

  const inspiFiltersMobileBtn = document.querySelector('[data-name="inspi-mobile-filters-btn"]');
  const hideFiltersMobileBtn = document.querySelector('[data-name="see-results-on-mobile"]');
  const inspiFiltersWrapper = document.querySelector('[data-name="mobile-inspi-filters-container"]');

  function showMobileFilters() {
    inspiFiltersWrapper.classList.add("Active");
    document.documentElement.classList.add("no-scroll");
  }

  function hideMobileFilters() {
    inspiFiltersWrapper.classList.remove("Active");
    document.documentElement.classList.remove("no-scroll");
  }

  inspiFiltersMobileBtn.addEventListener("click", showMobileFilters);
  hideFiltersMobileBtn.addEventListener("click", hideMobileFilters);

  function showFilterTabsBottom() {
    if (window.innerWidth < 1008) {
      if (window.scrollY > window.innerHeight * 0.6) {
        inspiFiltersMobileBtn.style.bottom = "20px";
      } else {
        inspiFiltersMobileBtn.style.bottom = "-80px";
      }
    }
  }

  window.addEventListener("scroll", showFilterTabsBottom);

  // ============== START DISABLE TAGS ON SPECIFIC TAG PAGE =================================================

  // use value of search field to filter
  var $quicksearch = $('[data-name="search-inspi-input"]').keyup(function () {
    document.querySelectorAll('[data-name="inspiration-filter-button-input"]').forEach((input) => {
      input.checked = false;
    });
    document.querySelectorAll('[data-name="inspiration-filter-btn-wrap"]').forEach((btn) => {
      btn.classList.remove("Active");
    });
    document.querySelectorAll('[data-name="inspiration-filter-btn"]').forEach((btn) => {
      btn.classList.remove("DotActive");
      btn.classList.remove("Active");
    });
    document.querySelector('[data-name="inspiration-empty-state"]').style.opacity = 0;
    document.querySelector('[data-name="inspiration-empty-state"]').style.pointerEvents = "none";
    document.querySelector('[data-name="tag-filter-clear-btn"]').classList.remove("Active");

    // quick search regex
    var qsRegex;
    // init Isotope
    var $container = $('[data-name="inspired-grid"]').isotope({
      itemSelector: '[data-name="inpired-item"]',
      layoutMode: "masonry",
      filter: function () {
        var $this = $(this);
        var searchResult = qsRegex ? $this.text().match(qsRegex) : true;
        return searchResult;
      },
    });

    console.log("typing");

    qsRegex = new RegExp($quicksearch.val(), "gi");
    $container.isotope({ layoutMode: "masonry", itemSelector: '[data-name="inpired-item"]' });
    window.location.hash = "";
    sessionStorage.removeItem("inspFilters");
    $container.isotope("layout");
  });

  // Clear all filters
  window.clearAllInspiFilters = function() {
    lottieLoaderPlaceholder();
    document.querySelectorAll('[data-name="inspiration-filters"] input').forEach((input) => {
      input.checked = false;
    });

    document.querySelectorAll('[data-name="inspiration-filter-btn"]').forEach((btn) => {
      btn.classList.remove("DotActive");
      btn.classList.remove("Active");
    });
    document.querySelectorAll('[data-name="inspiration-filter-btn-wrap"]').forEach((btn) => {
      btn.classList.remove("Active");
    });
    $container.isotope();
    filters = {};
    $container.isotope({ filter: "" });
    document.querySelector('[data-name="tag-filter-clear-btn"]').classList.remove("Active");
    document.querySelector('[data-name="inspiration-empty-state"]').style.opacity = 0;
    document.querySelector('[data-name="inspiration-empty-state"]').style.pointerEvents = "none";
    sessionStorage.removeItem("inspFilters");
    window.location.hash = "filters";
    setTimeout(() => {
      $container.isotope("layout");
    }, 1500);
  }
  document.querySelector('[data-name="tag-filter-clear-btn"]').addEventListener("click", clearAllInspiFilters);

  // Hide filters dropdown on click outsie button
  setTimeout(() => {
    document.addEventListener("click", (e) => {
      const flyoutEl = document.querySelector('[data-name="inspiration-filters"]');
      const flyoutEl2 = document.querySelector(".GetInspired__FilterButton--Item");
      let targetEl = e.target; // clicked element
      do {
        if (targetEl == flyoutEl || targetEl == flyoutEl2) {
          return;
        }
        targetEl = targetEl.parentNode;
      } while (targetEl);
      // This is a click outside.
      document.querySelectorAll('[data-name="inspiration-filter-btn-wrap"]').forEach((btn) => {
        if (btn.classList.contains("Active")) {
          btn.classList.remove("Active");
        }
      });
      document.querySelectorAll('[data-name="inspiration-filter-btn"]').forEach((btn) => {
        btn.classList.remove("Active");
      });
    });
  }, 200);

  // Combo filters - no results tiles
  function activateComboFilters(e) {
    if (e.target.parentElement.parentElement.getAttribute("data-name") != "combo-filter-inspo") return;
    const clickedElem = e.target.parentElement.parentElement.getAttribute("data-filter");

    switch (clickedElem) {
      case "living":
        clearAllInspiFilters();
        document.getElementById("living-room").click();
        document.getElementById("indoor").click();
        break;
      case "accessories":
        clearAllInspiFilters();
        document.getElementById("bookends").click();
        document.getElementById("candle-holders").click();
        document.getElementById("lamps").click();
        document.getElementById("mirrors").click();
        document.getElementById("candles").click();
        document.getElementById("umbrella-stands").click();
        document.getElementById("plant-pots").click();
        document.getElementById("coat-racks").click();
        document.getElementById("tableware").click();
        document.getElementById("bowls").click();
        document.getElementById("vases").click();
        document.getElementById("trays").click();
        document.getElementById("cushions").click();
        document.getElementById("throws").click();
        document.getElementById("rugs").click();
        break;
      case "dining":
        clearAllInspiFilters();
        document.getElementById("dining-room").click();
        document.getElementById("indoor").click();
        break;
      case "bedroom":
        clearAllInspiFilters();
        document.getElementById("bedroom").click();
        document.getElementById("indoor").click();
        break;
      case "accent":
        clearAllInspiFilters();
        document.getElementById("poufs").click();
        document.getElementById("stools").click();
        document.getElementById("benches").click();
        break;
      default:
        clearAllInspiFilters();
    }
  }

  document.querySelector('[data-name="inspiration-empty-state-list"]').addEventListener("click", activateComboFilters);

  // Add queris to the url address, base on checked filters, add one after another on every checked input
  function queriesCreator() {
    let queries = "filters";
    document.querySelectorAll('[data-name="inspiration-filters"] input:checked').forEach((checkbox) => {
      queries += `&${checkbox.id}`;
    });

    window.location.hash = queries;

    // Save all filters to the current session
    sessionStorage.setItem("inspFilters", queries);
  }

  setTimeout(() => {
    const currentUrl = window.location.href;
    if (currentUrl.indexOf("#filters") >= 1) {
      const splittedQueries = currentUrl.split("#filters")[1].split("&");
      splittedQueries.forEach((item) => {
        if (item != "") {
          document.getElementById(item).click();
        }
      });
    }
  }, 1000);

  function loadSessionStorageFilters() {
    if (sessionStorage.getItem("inspFilters") !== null) {
      window.location.hash = sessionStorage.getItem("inspFilters");
      console.log(sessionStorage.getItem("inspFilters"));
    }
  }
  loadSessionStorageFilters();

  // Show item if in the viewport
  function showTextInViewport(entries) {
    setTimeout(() => {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.querySelector(".LazyLoad").classList.add("Reveal");
          if (entry.target.querySelector('[data-name="inspired-badge"]')) {
            entry.target.querySelector('[data-name="inspired-badge"]').classList.add("Reveal");
          }
        }
      });
    }, 100);
  }

  // Setup our observer options
  let options = {
    threshold: "0.12",
  };

  // Create a new observerł
  let observer = new IntersectionObserver(showTextInViewport, options);

  // The element to observe
  let apps = document.querySelectorAll('[data-name="inpired-item"]');

  apps.forEach((i) => {
    if (i) {
      observer.observe(i);
    }
  });

  if (ua.indexOf("safari") != -1) {
    if (ua.indexOf("chrome") > -1) {
      setTimeout(() => {
        window.onscroll = function () {
          $container.isotope("layout");
          apps = document.querySelectorAll('[data-name="inpired-item"]');
          apps.forEach((i) => {
            if (i) {
              observer.observe(i);
            }
          });
        };
      }, 1000);
    } else {
      setTimeout(() => {
        window.onscroll = function () {
          $container.isotope("layout");
          apps = document.querySelectorAll('[data-name="inpired-item"]');
          apps.forEach((i) => {
            if (i) {
              observer.observe(i);
            }
          });
        };
      }, 3000);
    }
  }

  function lottieOnLoad() {
    const currentUrl = window.location.href;
    if (currentUrl.indexOf("&") >= 1) {
      setTimeout(() => {
        document.querySelector('[data-name="lottie-laceholder-inspi"]').classList.add("Hidden");
      }, 4600);
    } else {
      if (ua.indexOf("safari") != -1) {
        if (ua.indexOf("chrome") > -1) {
          setTimeout(() => {
            document.querySelector('[data-name="lottie-laceholder-inspi"]').classList.add("Hidden");
          }, 5000);
        } else {
          setTimeout(() => {
            document.querySelector('[data-name="lottie-laceholder-inspi"]').classList.add("Hidden");
          }, 6000);
        }
      }
    }
  }
  lottieOnLoad();

  function lottieLoaderPlaceholder() {
    const currentUrl = window.location.href;
    if (currentUrl.indexOf("&") >= 1) {
      document.querySelector('[data-name="lottie-laceholder-inspi"]').classList.remove("Hidden");
      setTimeout(() => {
        document.querySelector('[data-name="lottie-laceholder-inspi"]').classList.add("Hidden");
      }, 3900);
    } else {
      document.querySelector('[data-name="lottie-laceholder-inspi"]').classList.remove("Hidden");
      setTimeout(() => {
        document.querySelector('[data-name="lottie-laceholder-inspi"]').classList.add("Hidden");
      }, 3100);
    }
  }

  function checkUrlAndActiveFilters() {
    let url = window.location.href;
    let parts = url.split("&");
    parts[0] = parts[0].substring(parts[0].indexOf("#") + 1);

    setTimeout(() => {
      document.querySelectorAll('[data-name="inspiration-filters"] input').forEach((checkbox) => {
        if (parts.includes(checkbox.name) && checkbox.name !== "") {
          checkbox.click();
        }
      });
    }, 3000);
  }

  checkUrlAndActiveFilters();
})();
